@if (product$ | async; as product) {
  @if (showCaptchaContainer()) {
    <div [id]="gRecaptchaId()"></div>
  }
  <div class="d-flex flex-grow-1 w-100" [class.justify-content-center]="!isHeroSection && !isPublisherSection">
    <dcp-cta-webcomponent-wrapper
      [gRecaptchaId]="gRecaptchaId()"
      [isHeroSection]="isHeroSection"
      [isPublisherSection]="isPublisherSection"
      [product]="product"
      [bundleTemplate]="bundleTemplate"
      [ctaSelectionModalEnabled]="ctaSelectionModalEnabled()"></dcp-cta-webcomponent-wrapper>
  </div>
}
